// extracted by mini-css-extract-plugin
export default {"footer":"about_page_footer__EYanh"};